<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <footer>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="weight">
              <img class="motto" src="/motto.png" ><span class="footer-motto"> <a href="https://advicos.com/" > by Advicos sp. z o. o.</a></span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </nav>
</template>

<script>
export default {
  name: "app-layout-footer",

  methods: {
    getLayoutFooterBg() {
      return `bg-${this.layoutFooterBg}`;
    }
  }
};
</script>
